import React, {Component} from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import innerText from 'react-innertext'
import Analytics from '..'

const withAnalyticsOnChange = WrappedComponent =>
  class extends Component {
    static propTypes = {
      input: PropTypes.shape({
        name: PropTypes.string,
        onChange: PropTypes.func
      }).isRequired,
      meta: PropTypes.shape({error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])}).isRequired,
      label: PropTypes.any
    }

    static defaultProps = {label: ''}

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnChange`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !isEqual(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onChange = event => {
      const {input: {onChange}} = this.props

      onChange(event)

      setTimeout(() => {
        const {
            input: {name, value, checked},
            meta: {touched, error},
            label
          } = this.props,
          labelText = innerText(label)

        let valueText = `${value}`

        if (typeof value === 'boolean') {
          valueText = value ? 'checked' : 'unchecked'
        }

        if (value === undefined || value === null) {
          valueText = checked ? 'checked' : 'unchecked'
        }

        this.analytics.event({
          name,
          value: valueText || null,
          label: labelText,
          error: touched && error || null
        })
      }, 0)
    }

    render() {
      const {input, ...props} = this.props

      return (
        <WrappedComponent
          input={{...input, onChange: this.onChange}}
          {...props}
        />
      )
    }
  }

export default withAnalyticsOnChange
